export const checkIsDummyProduct = (value: string) => value === "Dummy";
